var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomOutdoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 58,
    viewBox: "0 0 95 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.43 37.13C68.476 37.13 76.62 28.9861 76.62 18.94C76.62 8.89394 68.476 0.75 58.43 0.75C48.3839 0.75 40.24 8.89394 40.24 18.94C40.24 28.9861 48.3839 37.13 58.43 37.13Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4299 12.52V57.4",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.43 28.2002L50.89 20.6602",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4299 19.3798L63.0499 14.7598",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5199 41.0998H35.9299C38.3399 41.0998 40.2899 43.0498 40.2899 45.4598V48.1398H13.6899L0.679932 19.7798",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6898 48.1396L7.83984 57.3997",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7499 41.0996L40.2999 57.3996",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1999 56.4201H80.3299L79.0499 41.1001H88.4799L87.1999 56.4201Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9201 32.0799C90.6377 32.0799 92.0301 30.6875 92.0301 28.9699C92.0301 27.2523 90.6377 25.8599 88.9201 25.8599C87.2025 25.8599 85.8101 27.2523 85.8101 28.9699C85.8101 30.6875 87.2025 32.0799 88.9201 32.0799Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3801 36.2499C92.6614 36.2499 93.7001 35.2112 93.7001 33.9299C93.7001 32.6486 92.6614 31.6099 91.3801 31.6099C90.0988 31.6099 89.0601 32.6486 89.0601 33.9299C89.0601 35.2112 90.0988 36.2499 91.3801 36.2499Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.77 41.0999C83.77 41.0999 82.89 34.9599 88.93 32.4399",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.45,
    height: 57.81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomOutdoor);
export default __webpack_public_path__ + "static/media/roomOutdoor.7e7e68c98b2cc0ed3f862c49f7a7659d.svg";
export { ForwardRef as ReactComponent };